export default __webpack_public_path__ + "static/media/medicinas.1789f591.jpg";